export default "__VITE_ASSET__DNVPSPkh__"